/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ShopOrder,
  NewShopOrder,
  RoleMappingCount200Response,
} from '../models/index';
import {
    ShopOrderFromJSON,
    ShopOrderToJSON,
    NewShopOrderFromJSON,
    NewShopOrderToJSON,
    RoleMappingCount200ResponseFromJSON,
} from '../models/index';

export interface ShopOrderCountRequest {
    where?: string;
}

export interface ShopOrderCreateRequest {
    data?: NewShopOrder;
}

export interface ShopOrderDeleteByIdRequest {
    id: string;
}

export interface ShopOrderFindRequest {
    filter?: string;
}

export interface ShopOrderFindByIdRequest {
    id: string;
    filter?: string;
}

export interface ShopOrderPrototypePatchAttributesRequest {
    id: string;
    data?: ShopOrder;
}

export interface ShopOrderUploadProofRequest {
    id: string;
    proofOfPayment: string;
}

export interface ShopOrderUpdateStatusRequest {
    id: string;
    status: string;
}

/**
 * 
 */
export class ShopOrderApi extends runtime.BaseAPI {

    /**
     * Count instances of the model matched by where from the data source.
     */
    async shopOrderCountRaw(requestParameters: ShopOrderCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShopOrders/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Count instances of the model matched by where from the data source.
     */
    async shopOrderCount(requestParameters: ShopOrderCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.shopOrderCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async shopOrderCreateRaw(requestParameters: ShopOrderCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopOrder>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ShopOrders`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewShopOrderToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopOrderFromJSON(jsonValue));
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async shopOrderCreate(requestParameters: ShopOrderCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopOrder> {
        const response = await this.shopOrderCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async shopOrderDeleteByIdRaw(requestParameters: ShopOrderDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling shopOrderDeleteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShopOrders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async shopOrderDeleteById(requestParameters: ShopOrderDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.shopOrderDeleteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async shopOrderFindRaw(requestParameters: ShopOrderFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShopOrder>>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShopOrders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ShopOrderFromJSON));
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async shopOrderFind(requestParameters: ShopOrderFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ShopOrder>> {
        const response = await this.shopOrderFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async shopOrderFindByIdRaw(requestParameters: ShopOrderFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopOrder>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling shopOrderFindById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShopOrders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopOrderFromJSON(jsonValue));
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async shopOrderFindById(requestParameters: ShopOrderFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopOrder> {
        const response = await this.shopOrderFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async shopOrderPrototypePatchAttributesRaw(requestParameters: ShopOrderPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopOrder>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling shopOrderPrototypePatchAttributes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ShopOrders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ShopOrderToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopOrderFromJSON(jsonValue));
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async shopOrderPrototypePatchAttributes(requestParameters: ShopOrderPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopOrder> {
        const response = await this.shopOrderPrototypePatchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload proof of payment for a shop order
     */
    async shopOrderUploadProofRaw(requestParameters: ShopOrderUploadProofRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopOrder>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling shopOrderUploadProof().'
            );
        }

        if (requestParameters['proofOfPayment'] == null) {
            throw new runtime.RequiredError(
                'proofOfPayment',
                'Required parameter "proofOfPayment" was null or undefined when calling shopOrderUploadProof().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ShopOrders/{id}/uploadProof`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: { proofOfPayment: requestParameters['proofOfPayment'] },
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopOrderFromJSON(jsonValue));
    }

    /**
     * Upload proof of payment for a shop order
     */
    async shopOrderUploadProof(requestParameters: ShopOrderUploadProofRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopOrder> {
        const response = await this.shopOrderUploadProofRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update status of a shop order
     */
    async shopOrderUpdateStatusRaw(requestParameters: ShopOrderUpdateStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopOrder>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling shopOrderUpdateStatus().'
            );
        }

        if (requestParameters['status'] == null) {
            throw new runtime.RequiredError(
                'status',
                'Required parameter "status" was null or undefined when calling shopOrderUpdateStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ShopOrders/{id}/updateStatus`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: { status: requestParameters['status'] },
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopOrderFromJSON(jsonValue));
    }

    /**
     * Update status of a shop order
     */
    async shopOrderUpdateStatus(requestParameters: ShopOrderUpdateStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopOrder> {
        const response = await this.shopOrderUpdateStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
